import { AppBar, Toolbar, IconButton, Typography } from '@mui/material'
import { header_shadow } from '../utils/little-parts'
import { useLayoutSideSize } from './GlobalLayout/GlobalLayout'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

type Props = {
  title?: React.ReactNode
  back: string
  children?: React.ReactNode
  barClick?: ()=> void
  onBack?: ()=> void
  back_disabled?: boolean
}
const LocalHeader: React.FC<Props> = ({title, back, children, barClick, onBack, back_disabled}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const location_state = useLocation().state as {from?: string} | undefined
  const side_size = useLayoutSideSize()
  const is_layout_slim = side_size === 0

  { /* enableColorOnDark: MUI v5以降、ダークモードでcolor propが無視されるためelevationベースの色が使われる。これを防ぐ */ }
  return <AppBar
    position='fixed' color='header' enableColorOnDark elevation={0}
    sx={is_layout_slim ? undefined : header_shadow}
  >
    <Toolbar>
      {back && <IconButton
        disabled={back_disabled}
        size='large' edge='start' color='inherit' aria-label={t('general.back')} sx={{mr: 1}}
        onClick={()=> {
          if (onBack) onBack()
          else if (location_state?.from) navigate(-1)
          else navigate(back)
        }}
      >
        <span className='material-icons' aria-hidden='true'>arrow_back</span>
      </IconButton>}

      <Typography
        variant='h2' component='div' fontSize='medium'
        sx={{
          flexGrow: 1,
          mr: children ? 1 : 5,
          fontWeight: 'bold',
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          textAlign: is_layout_slim ? 'center' : 'left'
        }}
        onClick={barClick}
      >
        {title}
      </Typography>

      {children}
    </Toolbar>
  </AppBar>
}
export default LocalHeader
